import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}
export function Input({
  label,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-127">
      {label && <label className="block text-xs font-medium uppercase tracking-widest text-neutral-400 mb-2" data-id="element-128">
          {label}
        </label>}
      <input className={`w-full bg-neutral-900 border border-neutral-800 px-4 py-3 text-white placeholder-neutral-500 focus:border-neutral-600 focus:outline-none focus:ring-0 transition-colors ${className}`} {...props} data-id="element-129" />
    </div>;
}